import { render } from "./Shops.vue?vue&type=template&id=71e86778"
import script from "./Shops.vue?vue&type=script&lang=js"
export * from "./Shops.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/data/dev.bl8m.it/vhosts/clients/client0/web144/web/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__